import type { FaireThemeEntity } from "../../entity_types/theme";

export const aloha_paper_goods: FaireThemeEntity = {
  token: "aloha-paper-goods",
  type: "theme",
  retailerToken: "r_bvuv8mj0x6",
  name: "Aloha Paper Goods",
  description: "Tropical stationery you can't find at chains",
  bgColor: "#D6E0F0",
  tileBgColor: "#9a3a2c",
  productTokens: [
    "p_g9mavdvwvq",
    "p_ks8vzdcg3e",
    "p_h58um9xn6f",
    "p_9u9jdhyh5z",
    "p_jsch2gcvju",
    "p_fgev7zxr4h",
    "p_yeu344evt3",
    "p_1tz8mvu4ol",
    "p_6mtc47gewb",
    "p_ts4fr63ear",
    "p_njjbfes7vs",
    "p_hpg8p7p5jh",
    "p_v2vnhbjgup",
    "p_tj9pxgjf3a",
    "p_3hbnvwqpdm",
    "p_fb52hxgf7x",
    "p_hw4zwr6eck",
    "p_yb3fru55e6",
    "p_evqmv73f77",
    "p_ddkt4eahtn",
    "p_m7zgp3q3yp",
    "p_vzbey9d7b2",
    "p_qqw4d9hdb6",
    "p_gdu8brkhd4",
    "p_kevdztuf8n",
    "p_usyg6sxx8v",
    "p_m6bvrm4ms8",
    "p_pwaxgj5caz",
    "p_6zfffhpjt3",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
